import { c as _c } from "react/compiler-runtime";
import { Chips, Separator, Switch } from 'platform/components';
import { HStack, VStack } from 'platform/foundation-tw';
import { isBoolean, isString } from 'ramda-adjunct';
import { suffixTestId } from 'shared/web';
import { useFilterOnChipsChange } from '../../hooks/useFilterOnChipsChange';
import type { EagFilterProps } from '../../types/EagFilterProps';
export type SwitchFilterProps = EagFilterProps & {
  quickFilters?: Array<{
    value: string;
    label: string;
  }>;
};
const FILTER_VALUE_KEY = 'value';
export function SwitchFilter(props) {
  const $ = _c(22);
  const model = props.value[FILTER_VALUE_KEY] as string | boolean | null;
  let t0;
  if ($[0] !== props) {
    t0 = newModel => {
      props.onChange({
        [FILTER_VALUE_KEY]: newModel ?? null
      });
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const setValue = t0;
  let t1;
  if ($[2] !== setValue) {
    t1 = {
      setFilterValue: setValue,
      defaultValue: false
    };
    $[2] = setValue;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    onChipsChange
  } = useFilterOnChipsChange(t1);
  let t2;
  if ($[4] !== setValue) {
    t2 = value => {
      setValue(value);
    };
    $[4] = setValue;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onChange = t2;
  let t3;
  if ($[6] !== model) {
    t3 = isString(model) ? [model] : null;
    $[6] = model;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const isQuickFilterValue = t3;
  const isValue = isBoolean(model) ? model : false;
  let t4;
  if ($[8] !== isQuickFilterValue || $[9] !== onChipsChange || $[10] !== props) {
    t4 = props.quickFilters && props.quickFilters.length > 0 && <><HStack><Chips isDisabled={props.isDisabled} value={isQuickFilterValue} options={props.quickFilters} onChange={onChipsChange} isMultiple={false} data-testid={suffixTestId("switch-filter-quickFilters", props)} isDeselectable={true} /></HStack><Separator /></>;
    $[8] = isQuickFilterValue;
    $[9] = onChipsChange;
    $[10] = props;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = props.isDisabled;
  let t6;
  if ($[12] !== props) {
    t6 = suffixTestId("switch-filter", props);
    $[12] = props;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== isValue || $[15] !== onChange || $[16] !== props.isDisabled || $[17] !== t6) {
    t7 = <Switch isDisabled={t5} value={isValue} onChange={onChange} data-testid={t6} />;
    $[14] = isValue;
    $[15] = onChange;
    $[16] = props.isDisabled;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t4 || $[20] !== t7) {
    t8 = <VStack>{t4}{t7}</VStack>;
    $[19] = t4;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}